import { CommunityCard } from '@/components/CommunityCard'
import { CardGrid } from '@/components/CardGrid'

const FPO_IMAGE = '/wp-content/plugins/ecs-spaces/public/images/spaces-fpo.png'
const CONTACT_LINK = { url: 'tel:3035550100', title: 'Contact', target: '' }

function Section ({
	title,
	children
}: {
	title: string
	children: React.ReactNode
}) {
	return (
		<div className='spaces:flex spaces:flex-col spaces:gap-16'>
			<h3 className='spaces:text-14 spaces:font-semi spaces:text-content-3 spaces:uppercase spaces:tracking-wide'>
				{title}
			</h3>
			{children}
		</div>
	)
}

export function CommunityCardSandbox () {
	return (
		<div className='spaces:flex spaces:flex-col spaces:gap-32'>
			<Section title='hasFees = true'>
				<CardGrid columns={4}>
					<CommunityCard
						name='Milo (Garden)'
						imageUrl={FPO_IMAGE}
						phone='(303) 555-0100'
						phoneHref='tel:3035550100'
						matchingUnits={12}
						totalPrice='$1,845'
						baseRent='$1,650'
						leaseTerm='12 Mo.'
						hasFees
						hasDisclaimerSymbol
					/>
					<CommunityCard
						name='Milo (High Rise)'
						imageUrl={FPO_IMAGE}
						phone='(303) 555-0101'
						phoneHref='tel:3035550101'
						matchingUnits={4}
						pricing='hidden'
						contactLink={CONTACT_LINK}
						hasFees
					/>
				</CardGrid>
			</Section>
			<Section title='hasFees = false'>
				<CardGrid columns={4}>
					<CommunityCard
						name='The Alpine'
						imageUrl={FPO_IMAGE}
						matchingUnits={7}
						baseRent='$1,650'
						leaseTerm='12 Mo.'
						hasFees={false}
						hasDisclaimerSymbol
					/>
					<CommunityCard
						name='The Birch'
						imageUrl={FPO_IMAGE}
						matchingUnits={2}
						pricing='hidden'
						hasFees={false}
					/>
				</CardGrid>
			</Section>
		</div>
	)
}
